import React, { useState } from 'react';

import { capitalize } from 'lodash';

import { usePractitionerImportDataContext } from 'lib/context/PractitionerImportDataContext/PractitionerImportDataContext';

import Step from './Step';

const steps = ['macros'];

const MultiStepForm = () => {
  const { importAll, sourcePractice } = usePractitionerImportDataContext();
  const [currentStep, setCurrentStep] = useState(0);

  return (
    <div className="!pt-4">
      {!importAll && sourcePractice && (
        <>
          <div className="flex items-center gap-2 rounded bg-white !p-2 shadow-sm">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`cursor-pointer rounded-md p-2 ${
                  currentStep === index ? 'bg-primary-50 text-primary-500' : ''
                }`}
                onClick={() => setCurrentStep(index)}>
                {capitalize(step)}
              </div>
            ))}
          </div>

          <Step stepName={steps[currentStep]} />
        </>
      )}
    </div>
  );
};

export default MultiStepForm;
